import React from 'react';
import { Link } from 'react-router-dom';
interface RichTextProps {
  text: string;
  lang: string;
  linkClassName: string;
}
const LINK_PATTERN = /\[([^\]]+)\]\(([^)]+)\)/g;

/** Renders text containing `[anchor](/path)` inline links as router links. */
export function RichText({
  text,
  lang,
  linkClassName
}: RichTextProps) {
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  LINK_PATTERN.lastIndex = 0;
  while ((match = LINK_PATTERN.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    const [, anchor, path] = match;
    parts.push(<Link key={match.index} to={`/${lang}${path}`} className={linkClassName} data-id="element-234" data-mp="3oez37vky0e87">
        {anchor}
      </Link>);
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < text.length) parts.push(text.slice(lastIndex));
  return <>{parts}</>;
}